import React, { useEffect, useState } from "react";
import Nav from "@/components/Nav";
import { api } from "@/lib/api";

export default function Mentors() {
  const [mentors, setMentors] = useState([]);
  useEffect(() => { (async () => setMentors(await api.mentors()))(); }, []);

  return (
    <div className="bg-[color:var(--f2-bg)] min-h-screen text-white">
      <Nav />
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16">
        <div className="label-xs mb-2">§ Mentorship</div>
        <h1 className="font-display uppercase tracking-tighter font-black text-4xl md:text-6xl mb-10">
          Learn from <span className="saffron">mission veterans.</span>
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {mentors.map((m) => (
            <div key={m.mentor_id} data-testid={`mentor-${m.mentor_id}`} className="hard-border p-6 bg-[color:var(--f2-surface)]">
              <div className="flex justify-between items-start mb-4">
                <div>
                  <div className="font-display font-bold text-xl">{m.name}</div>
                  <div className="label-xs mt-1">{m.title}</div>
                </div>
                <span className="live-dot mt-2" />
              </div>
              <div className="flex flex-wrap gap-2 mb-4">
                {m.expertise?.map((e) => (
                  <span key={e} className="text-xs border border-[color:var(--f2-border)] px-2 py-1">{e}</span>
                ))}
              </div>
              <div className="flex justify-between text-xs text-[color:var(--f2-muted)]">
                <span>{m.location}</span>
                <span className="saffron">{m.availability}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
